"use client";

import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import ApiKeys from "../../components/api-keys/api-keys";
import { DatabaseConnections } from "../../components/database-connections/database-connections";
import { ApiConnections } from "../../components/api-connections/api-connections";
import { useOrganizations } from "../../hooks/useOrganizations";

/**
 * Credentials: lo que identifica a esta cuenta ante algo de afuera.
 *
 * Tres clases distintas —las llaves de la API, las conexiones a bases de
 * datos y las APIs externas que llama el step api_call— así que pestañas y no
 * secciones del menú.
 *
 * **El título ya no se puede esconder.** Existía un `hideTitle` para cuando
 * esto vivía dentro de una pestaña de Connections, que ponía el suyo. Esa
 * pestaña se retiró y la bandera se quedó puesta, así que la pantalla
 * arrancaba con un subtítulo huérfano y "API Keys" hacía de título de página
 * y de subsección a la vez.
 */
export default function SettingsView() {
  const { currentContext, currentAccount } = useOrganizations();

  const contextType = currentContext?.type || "PERSONAL";
  const contextName =
    contextType === "PERSONAL"
      ? "your personal account"
      : currentAccount?.name || "this organization";

  return (
    <section className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Credentials</h1>
        <p className="mt-1 text-sm text-gray-400">
          API keys, database and API connections for {contextName}.
        </p>
      </div>

      <Tabs defaultValue="api" className="w-full">
        {/* Compacto y del ancho de su contenido. A ancho completo era un
            segundo selector grande debajo de un menú lateral que ya pesa: dos
            capas de navegación compitiendo por la misma atención. */}
        <TabsList className="mb-6 inline-flex gap-1 rounded-lg border border-white/10 bg-[#0F1117] p-1">
          <TabsTrigger
            value="api"
            className="rounded-md px-3 py-1.5 text-sm font-medium transition-colors
                       ui-selected:bg-primary ui-selected:text-white
                       ui-not-selected:text-gray-400 ui-not-selected:hover:text-white"
          >
            API Keys
          </TabsTrigger>
          <TabsTrigger
            value="db"
            className="rounded-md px-3 py-1.5 text-sm font-medium transition-colors
                       ui-selected:bg-primary ui-selected:text-white
                       ui-not-selected:text-gray-400 ui-not-selected:hover:text-white"
          >
            DB Connections
          </TabsTrigger>
          <TabsTrigger
            value="external-api"
            className="rounded-md px-3 py-1.5 text-sm font-medium transition-colors
                       ui-selected:bg-primary ui-selected:text-white
                       ui-not-selected:text-gray-400 ui-not-selected:hover:text-white"
          >
            API Connections
          </TabsTrigger>
        </TabsList>

        <TabsContent value="api">
          <ApiKeys />
        </TabsContent>
        <TabsContent value="db">
          <DatabaseConnections />
        </TabsContent>
        <TabsContent value="external-api">
          <ApiConnections />
        </TabsContent>
      </Tabs>
    </section>
  );
}
